import { Stack, SxProps } from "@mui/material";
import CardSkeleton from "./CardSkeleton";
import { FC } from "react";

interface CardsListSkeletonProps {
  sx?: SxProps;
  listLength?: number;
  cardBodyHeight?: string;
}

const CardsListSkeleton: FC<CardsListSkeletonProps> = ({
  listLength = 10,
  sx,
  cardBodyHeight = "289px",
}) => {
  return (
    <Stack sx={sx} pt="16px" direction="column" gap="8px">
      {Array.from({ length: listLength }, () => (
        <CardSkeleton bodyHeight={cardBodyHeight} />
      ))}
    </Stack>
  );
};

export default CardsListSkeleton;
